/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CampaignResponse } from '../models';
// @ts-ignore
import type { CreateCampaignBody } from '../models';
// @ts-ignore
import type { CreateSequenceFromAudienceBody } from '../models';
// @ts-ignore
import type { CreateSequenceFromAudienceResponse } from '../models';
// @ts-ignore
import type { CreditSummaryResponse } from '../models';
// @ts-ignore
import type { DeleteCampaignResponse } from '../models';
// @ts-ignore
import type { EnrichHiringBody } from '../models';
// @ts-ignore
import type { EnrichHiringResponse } from '../models';
// @ts-ignore
import type { EnrollProspectsBody } from '../models';
// @ts-ignore
import type { EnrollProspectsResponse } from '../models';
// @ts-ignore
import type { EnrollmentHistoryResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { EstimateRevealBody } from '../models';
// @ts-ignore
import type { EstimateRevealResponse } from '../models';
// @ts-ignore
import type { ExportForClaudeResponse } from '../models';
// @ts-ignore
import type { GetAllProspectsResponse } from '../models';
// @ts-ignore
import type { IngestReplyBody } from '../models';
// @ts-ignore
import type { IngestReplyResponse } from '../models';
// @ts-ignore
import type { ListCampaignsResponse } from '../models';
// @ts-ignore
import type { ListEnrollmentsResponse } from '../models';
// @ts-ignore
import type { MarkEnrollmentBody } from '../models';
// @ts-ignore
import type { MarkEnrollmentResponse } from '../models';
// @ts-ignore
import type { RevealProspectsBody } from '../models';
// @ts-ignore
import type { RevealProspectsResponse } from '../models';
// @ts-ignore
import type { SearchCountResponse } from '../models';
// @ts-ignore
import type { SearchProspectsBody } from '../models';
// @ts-ignore
import type { SearchProspectsResponse } from '../models';
// @ts-ignore
import type { SendOutreachEmailsBody } from '../models';
// @ts-ignore
import type { SendOutreachEmailsResponse } from '../models';
// @ts-ignore
import type { SetCampaignStatusBody } from '../models';
// @ts-ignore
import type { SetCreditsBody } from '../models';
// @ts-ignore
import type { TagSuggestResponse } from '../models';
// @ts-ignore
import type { ToggleIgnoreResponse } from '../models';
// @ts-ignore
import type { UpdateCampaignBody } from '../models';
/**
 * OutreachApiApi - axios parameter creator
 */
export const OutreachApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateCampaignBody} createCampaignBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiCreateCampaign: async (createCampaignBody: CreateCampaignBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCampaignBody' is not null or undefined
            assertParamExists('outreachApiCreateCampaign', 'createCampaignBody', createCampaignBody)
            const localVarPath = `/admin/outreach/campaigns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCampaignBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSequenceFromAudienceBody} createSequenceFromAudienceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiCreateSequenceFromAudience: async (createSequenceFromAudienceBody: CreateSequenceFromAudienceBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSequenceFromAudienceBody' is not null or undefined
            assertParamExists('outreachApiCreateSequenceFromAudience', 'createSequenceFromAudienceBody', createSequenceFromAudienceBody)
            const localVarPath = `/admin/outreach/sequences/from-audience`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSequenceFromAudienceBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiCreditSummary: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/outreach/credits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiDeleteCampaign: async (campaignId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('outreachApiDeleteCampaign', 'campaignId', campaignId)
            const localVarPath = `/admin/outreach/campaigns/{campaign_id}`
                .replace('{campaign_id}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EnrichHiringBody} enrichHiringBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiEnrichHiring: async (enrichHiringBody: EnrichHiringBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enrichHiringBody' is not null or undefined
            assertParamExists('outreachApiEnrichHiring', 'enrichHiringBody', enrichHiringBody)
            const localVarPath = `/admin/outreach/prospects/enrich-hiring`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(enrichHiringBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {EnrollProspectsBody} enrollProspectsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiEnrollProspects: async (campaignId: string, enrollProspectsBody: EnrollProspectsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('outreachApiEnrollProspects', 'campaignId', campaignId)
            // verify required parameter 'enrollProspectsBody' is not null or undefined
            assertParamExists('outreachApiEnrollProspects', 'enrollProspectsBody', enrollProspectsBody)
            const localVarPath = `/admin/outreach/campaigns/{campaign_id}/enroll`
                .replace('{campaign_id}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(enrollProspectsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} enrollmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiEnrollmentHistory: async (enrollmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enrollmentId' is not null or undefined
            assertParamExists('outreachApiEnrollmentHistory', 'enrollmentId', enrollmentId)
            const localVarPath = `/admin/outreach/enrollments/{enrollment_id}/history`
                .replace('{enrollment_id}', encodeURIComponent(String(enrollmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EstimateRevealBody} estimateRevealBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiEstimateReveal: async (estimateRevealBody: EstimateRevealBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'estimateRevealBody' is not null or undefined
            assertParamExists('outreachApiEstimateReveal', 'estimateRevealBody', estimateRevealBody)
            const localVarPath = `/admin/outreach/prospects/estimate-reveal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(estimateRevealBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {boolean} [onlyUnknown] 
         * @param {string | null} [searchBatchId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiExportForClaude: async (limit?: number, onlyUnknown?: boolean, searchBatchId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/outreach/prospects/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (onlyUnknown !== undefined) {
                localVarQueryParameter['only_unknown'] = onlyUnknown;
            }

            if (searchBatchId !== undefined) {
                localVarQueryParameter['search_batch_id'] = searchBatchId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiGetCampaign: async (campaignId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('outreachApiGetCampaign', 'campaignId', campaignId)
            const localVarPath = `/admin/outreach/campaigns/{campaign_id}`
                .replace('{campaign_id}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {IngestReplyBody} ingestReplyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiInboundReply: async (ingestReplyBody: IngestReplyBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ingestReplyBody' is not null or undefined
            assertParamExists('outreachApiInboundReply', 'ingestReplyBody', ingestReplyBody)
            const localVarPath = `/admin/outreach/inbound-reply`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ingestReplyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiListCampaigns: async (status?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/outreach/campaigns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [search] 
         * @param {string | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiListEnrollments: async (campaignId: string, page?: number, pageSize?: number, search?: string | null, status?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('outreachApiListEnrollments', 'campaignId', campaignId)
            const localVarPath = `/admin/outreach/campaigns/{campaign_id}/enrollments`
                .replace('{campaign_id}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean | null} [hasAccount] 
         * @param {boolean | null} [hasEmail] 
         * @param {string | null} [hiringStatus] 
         * @param {string | null} [hiringType] 
         * @param {boolean} [includeIgnored] 
         * @param {boolean | null} [isStaffingFirm] 
         * @param {number | null} [minValueScore] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [revealStatus] 
         * @param {string | null} [roleCategory] 
         * @param {string | null} [searchBatchId] 
         * @param {string | null} [searchQuery] 
         * @param {string} [sort] 
         * @param {string | null} [sortDir] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiListProspects: async (hasAccount?: boolean | null, hasEmail?: boolean | null, hiringStatus?: string | null, hiringType?: string | null, includeIgnored?: boolean, isStaffingFirm?: boolean | null, minValueScore?: number | null, page?: number, pageSize?: number, revealStatus?: string | null, roleCategory?: string | null, searchBatchId?: string | null, searchQuery?: string | null, sort?: string, sortDir?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/outreach/prospects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (hasAccount !== undefined) {
                localVarQueryParameter['has_account'] = hasAccount;
            }

            if (hasEmail !== undefined) {
                localVarQueryParameter['has_email'] = hasEmail;
            }

            if (hiringStatus !== undefined) {
                localVarQueryParameter['hiring_status'] = hiringStatus;
            }

            if (hiringType !== undefined) {
                localVarQueryParameter['hiring_type'] = hiringType;
            }

            if (includeIgnored !== undefined) {
                localVarQueryParameter['include_ignored'] = includeIgnored;
            }

            if (isStaffingFirm !== undefined) {
                localVarQueryParameter['is_staffing_firm'] = isStaffingFirm;
            }

            if (minValueScore !== undefined) {
                localVarQueryParameter['min_value_score'] = minValueScore;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (revealStatus !== undefined) {
                localVarQueryParameter['reveal_status'] = revealStatus;
            }

            if (roleCategory !== undefined) {
                localVarQueryParameter['role_category'] = roleCategory;
            }

            if (searchBatchId !== undefined) {
                localVarQueryParameter['search_batch_id'] = searchBatchId;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (sortDir !== undefined) {
                localVarQueryParameter['sort_dir'] = sortDir;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} enrollmentId 
         * @param {MarkEnrollmentBody} markEnrollmentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiMarkEnrollment: async (enrollmentId: string, markEnrollmentBody: MarkEnrollmentBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enrollmentId' is not null or undefined
            assertParamExists('outreachApiMarkEnrollment', 'enrollmentId', enrollmentId)
            // verify required parameter 'markEnrollmentBody' is not null or undefined
            assertParamExists('outreachApiMarkEnrollment', 'markEnrollmentBody', markEnrollmentBody)
            const localVarPath = `/admin/outreach/enrollments/{enrollment_id}`
                .replace('{enrollment_id}', encodeURIComponent(String(enrollmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markEnrollmentBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RevealProspectsBody} revealProspectsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiRevealProspects: async (revealProspectsBody: RevealProspectsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'revealProspectsBody' is not null or undefined
            assertParamExists('outreachApiRevealProspects', 'revealProspectsBody', revealProspectsBody)
            const localVarPath = `/admin/outreach/prospects/reveal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(revealProspectsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SearchProspectsBody} searchProspectsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiSearchCount: async (searchProspectsBody: SearchProspectsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchProspectsBody' is not null or undefined
            assertParamExists('outreachApiSearchCount', 'searchProspectsBody', searchProspectsBody)
            const localVarPath = `/admin/outreach/search-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchProspectsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SearchProspectsBody} searchProspectsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiSearchProspects: async (searchProspectsBody: SearchProspectsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchProspectsBody' is not null or undefined
            assertParamExists('outreachApiSearchProspects', 'searchProspectsBody', searchProspectsBody)
            const localVarPath = `/admin/outreach/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchProspectsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendOutreachEmailsBody} sendOutreachEmailsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiSendOutreachEmails: async (sendOutreachEmailsBody: SendOutreachEmailsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendOutreachEmailsBody' is not null or undefined
            assertParamExists('outreachApiSendOutreachEmails', 'sendOutreachEmailsBody', sendOutreachEmailsBody)
            const localVarPath = `/admin/outreach/send-emails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendOutreachEmailsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {SetCampaignStatusBody} setCampaignStatusBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiSetCampaignStatus: async (campaignId: string, setCampaignStatusBody: SetCampaignStatusBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('outreachApiSetCampaignStatus', 'campaignId', campaignId)
            // verify required parameter 'setCampaignStatusBody' is not null or undefined
            assertParamExists('outreachApiSetCampaignStatus', 'setCampaignStatusBody', setCampaignStatusBody)
            const localVarPath = `/admin/outreach/campaigns/{campaign_id}/status`
                .replace('{campaign_id}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setCampaignStatusBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetCreditsBody} setCreditsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiSetCredits: async (setCreditsBody: SetCreditsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setCreditsBody' is not null or undefined
            assertParamExists('outreachApiSetCredits', 'setCreditsBody', setCreditsBody)
            const localVarPath = `/admin/outreach/credits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setCreditsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} q 
         * @param {string | null} [kind] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiTagSuggest: async (q: string, kind?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('outreachApiTagSuggest', 'q', q)
            const localVarPath = `/admin/outreach/tag-suggest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} prospectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiToggleIgnoreProspect: async (prospectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prospectId' is not null or undefined
            assertParamExists('outreachApiToggleIgnoreProspect', 'prospectId', prospectId)
            const localVarPath = `/admin/outreach/prospects/{prospect_id}/ignore`
                .replace('{prospect_id}', encodeURIComponent(String(prospectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {UpdateCampaignBody} updateCampaignBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiUpdateCampaign: async (campaignId: string, updateCampaignBody: UpdateCampaignBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('outreachApiUpdateCampaign', 'campaignId', campaignId)
            // verify required parameter 'updateCampaignBody' is not null or undefined
            assertParamExists('outreachApiUpdateCampaign', 'updateCampaignBody', updateCampaignBody)
            const localVarPath = `/admin/outreach/campaigns/{campaign_id}`
                .replace('{campaign_id}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCampaignBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OutreachApiApi - functional programming interface
 */
export const OutreachApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OutreachApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateCampaignBody} createCampaignBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachApiCreateCampaign(createCampaignBody: CreateCampaignBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachApiCreateCampaign(createCampaignBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutreachApiApi.outreachApiCreateCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateSequenceFromAudienceBody} createSequenceFromAudienceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachApiCreateSequenceFromAudience(createSequenceFromAudienceBody: CreateSequenceFromAudienceBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateSequenceFromAudienceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachApiCreateSequenceFromAudience(createSequenceFromAudienceBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutreachApiApi.outreachApiCreateSequenceFromAudience']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachApiCreditSummary(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreditSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachApiCreditSummary(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutreachApiApi.outreachApiCreditSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachApiDeleteCampaign(campaignId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteCampaignResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachApiDeleteCampaign(campaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutreachApiApi.outreachApiDeleteCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EnrichHiringBody} enrichHiringBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachApiEnrichHiring(enrichHiringBody: EnrichHiringBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnrichHiringResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachApiEnrichHiring(enrichHiringBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutreachApiApi.outreachApiEnrichHiring']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {EnrollProspectsBody} enrollProspectsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachApiEnrollProspects(campaignId: string, enrollProspectsBody: EnrollProspectsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnrollProspectsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachApiEnrollProspects(campaignId, enrollProspectsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutreachApiApi.outreachApiEnrollProspects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} enrollmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachApiEnrollmentHistory(enrollmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnrollmentHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachApiEnrollmentHistory(enrollmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutreachApiApi.outreachApiEnrollmentHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EstimateRevealBody} estimateRevealBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachApiEstimateReveal(estimateRevealBody: EstimateRevealBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EstimateRevealResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachApiEstimateReveal(estimateRevealBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutreachApiApi.outreachApiEstimateReveal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {boolean} [onlyUnknown] 
         * @param {string | null} [searchBatchId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachApiExportForClaude(limit?: number, onlyUnknown?: boolean, searchBatchId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportForClaudeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachApiExportForClaude(limit, onlyUnknown, searchBatchId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutreachApiApi.outreachApiExportForClaude']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachApiGetCampaign(campaignId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachApiGetCampaign(campaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutreachApiApi.outreachApiGetCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {IngestReplyBody} ingestReplyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachApiInboundReply(ingestReplyBody: IngestReplyBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IngestReplyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachApiInboundReply(ingestReplyBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutreachApiApi.outreachApiInboundReply']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachApiListCampaigns(status?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCampaignsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachApiListCampaigns(status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutreachApiApi.outreachApiListCampaigns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [search] 
         * @param {string | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachApiListEnrollments(campaignId: string, page?: number, pageSize?: number, search?: string | null, status?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListEnrollmentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachApiListEnrollments(campaignId, page, pageSize, search, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutreachApiApi.outreachApiListEnrollments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean | null} [hasAccount] 
         * @param {boolean | null} [hasEmail] 
         * @param {string | null} [hiringStatus] 
         * @param {string | null} [hiringType] 
         * @param {boolean} [includeIgnored] 
         * @param {boolean | null} [isStaffingFirm] 
         * @param {number | null} [minValueScore] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [revealStatus] 
         * @param {string | null} [roleCategory] 
         * @param {string | null} [searchBatchId] 
         * @param {string | null} [searchQuery] 
         * @param {string} [sort] 
         * @param {string | null} [sortDir] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachApiListProspects(hasAccount?: boolean | null, hasEmail?: boolean | null, hiringStatus?: string | null, hiringType?: string | null, includeIgnored?: boolean, isStaffingFirm?: boolean | null, minValueScore?: number | null, page?: number, pageSize?: number, revealStatus?: string | null, roleCategory?: string | null, searchBatchId?: string | null, searchQuery?: string | null, sort?: string, sortDir?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllProspectsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachApiListProspects(hasAccount, hasEmail, hiringStatus, hiringType, includeIgnored, isStaffingFirm, minValueScore, page, pageSize, revealStatus, roleCategory, searchBatchId, searchQuery, sort, sortDir, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutreachApiApi.outreachApiListProspects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} enrollmentId 
         * @param {MarkEnrollmentBody} markEnrollmentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachApiMarkEnrollment(enrollmentId: string, markEnrollmentBody: MarkEnrollmentBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarkEnrollmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachApiMarkEnrollment(enrollmentId, markEnrollmentBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutreachApiApi.outreachApiMarkEnrollment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RevealProspectsBody} revealProspectsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachApiRevealProspects(revealProspectsBody: RevealProspectsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RevealProspectsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachApiRevealProspects(revealProspectsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutreachApiApi.outreachApiRevealProspects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SearchProspectsBody} searchProspectsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachApiSearchCount(searchProspectsBody: SearchProspectsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchCountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachApiSearchCount(searchProspectsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutreachApiApi.outreachApiSearchCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SearchProspectsBody} searchProspectsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachApiSearchProspects(searchProspectsBody: SearchProspectsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchProspectsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachApiSearchProspects(searchProspectsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutreachApiApi.outreachApiSearchProspects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendOutreachEmailsBody} sendOutreachEmailsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachApiSendOutreachEmails(sendOutreachEmailsBody: SendOutreachEmailsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendOutreachEmailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachApiSendOutreachEmails(sendOutreachEmailsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutreachApiApi.outreachApiSendOutreachEmails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {SetCampaignStatusBody} setCampaignStatusBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachApiSetCampaignStatus(campaignId: string, setCampaignStatusBody: SetCampaignStatusBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachApiSetCampaignStatus(campaignId, setCampaignStatusBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutreachApiApi.outreachApiSetCampaignStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SetCreditsBody} setCreditsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachApiSetCredits(setCreditsBody: SetCreditsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreditSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachApiSetCredits(setCreditsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutreachApiApi.outreachApiSetCredits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} q 
         * @param {string | null} [kind] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachApiTagSuggest(q: string, kind?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TagSuggestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachApiTagSuggest(q, kind, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutreachApiApi.outreachApiTagSuggest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} prospectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachApiToggleIgnoreProspect(prospectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ToggleIgnoreResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachApiToggleIgnoreProspect(prospectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutreachApiApi.outreachApiToggleIgnoreProspect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {UpdateCampaignBody} updateCampaignBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outreachApiUpdateCampaign(campaignId: string, updateCampaignBody: UpdateCampaignBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outreachApiUpdateCampaign(campaignId, updateCampaignBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutreachApiApi.outreachApiUpdateCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OutreachApiApi - factory interface
 */
export const OutreachApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OutreachApiApiFp(configuration)
    return {
        /**
         * 
         * @param {OutreachApiApiOutreachApiCreateCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiCreateCampaign(requestParameters: OutreachApiApiOutreachApiCreateCampaignRequest, options?: RawAxiosRequestConfig): AxiosPromise<CampaignResponse> {
            return localVarFp.outreachApiCreateCampaign(requestParameters.createCampaignBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutreachApiApiOutreachApiCreateSequenceFromAudienceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiCreateSequenceFromAudience(requestParameters: OutreachApiApiOutreachApiCreateSequenceFromAudienceRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateSequenceFromAudienceResponse> {
            return localVarFp.outreachApiCreateSequenceFromAudience(requestParameters.createSequenceFromAudienceBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiCreditSummary(options?: RawAxiosRequestConfig): AxiosPromise<CreditSummaryResponse> {
            return localVarFp.outreachApiCreditSummary(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutreachApiApiOutreachApiDeleteCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiDeleteCampaign(requestParameters: OutreachApiApiOutreachApiDeleteCampaignRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteCampaignResponse> {
            return localVarFp.outreachApiDeleteCampaign(requestParameters.campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutreachApiApiOutreachApiEnrichHiringRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiEnrichHiring(requestParameters: OutreachApiApiOutreachApiEnrichHiringRequest, options?: RawAxiosRequestConfig): AxiosPromise<EnrichHiringResponse> {
            return localVarFp.outreachApiEnrichHiring(requestParameters.enrichHiringBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutreachApiApiOutreachApiEnrollProspectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiEnrollProspects(requestParameters: OutreachApiApiOutreachApiEnrollProspectsRequest, options?: RawAxiosRequestConfig): AxiosPromise<EnrollProspectsResponse> {
            return localVarFp.outreachApiEnrollProspects(requestParameters.campaignId, requestParameters.enrollProspectsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutreachApiApiOutreachApiEnrollmentHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiEnrollmentHistory(requestParameters: OutreachApiApiOutreachApiEnrollmentHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<EnrollmentHistoryResponse> {
            return localVarFp.outreachApiEnrollmentHistory(requestParameters.enrollmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutreachApiApiOutreachApiEstimateRevealRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiEstimateReveal(requestParameters: OutreachApiApiOutreachApiEstimateRevealRequest, options?: RawAxiosRequestConfig): AxiosPromise<EstimateRevealResponse> {
            return localVarFp.outreachApiEstimateReveal(requestParameters.estimateRevealBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutreachApiApiOutreachApiExportForClaudeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiExportForClaude(requestParameters: OutreachApiApiOutreachApiExportForClaudeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ExportForClaudeResponse> {
            return localVarFp.outreachApiExportForClaude(requestParameters.limit, requestParameters.onlyUnknown, requestParameters.searchBatchId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutreachApiApiOutreachApiGetCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiGetCampaign(requestParameters: OutreachApiApiOutreachApiGetCampaignRequest, options?: RawAxiosRequestConfig): AxiosPromise<CampaignResponse> {
            return localVarFp.outreachApiGetCampaign(requestParameters.campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutreachApiApiOutreachApiInboundReplyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiInboundReply(requestParameters: OutreachApiApiOutreachApiInboundReplyRequest, options?: RawAxiosRequestConfig): AxiosPromise<IngestReplyResponse> {
            return localVarFp.outreachApiInboundReply(requestParameters.ingestReplyBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutreachApiApiOutreachApiListCampaignsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiListCampaigns(requestParameters: OutreachApiApiOutreachApiListCampaignsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListCampaignsResponse> {
            return localVarFp.outreachApiListCampaigns(requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutreachApiApiOutreachApiListEnrollmentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiListEnrollments(requestParameters: OutreachApiApiOutreachApiListEnrollmentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListEnrollmentsResponse> {
            return localVarFp.outreachApiListEnrollments(requestParameters.campaignId, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutreachApiApiOutreachApiListProspectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiListProspects(requestParameters: OutreachApiApiOutreachApiListProspectsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAllProspectsResponse> {
            return localVarFp.outreachApiListProspects(requestParameters.hasAccount, requestParameters.hasEmail, requestParameters.hiringStatus, requestParameters.hiringType, requestParameters.includeIgnored, requestParameters.isStaffingFirm, requestParameters.minValueScore, requestParameters.page, requestParameters.pageSize, requestParameters.revealStatus, requestParameters.roleCategory, requestParameters.searchBatchId, requestParameters.searchQuery, requestParameters.sort, requestParameters.sortDir, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutreachApiApiOutreachApiMarkEnrollmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiMarkEnrollment(requestParameters: OutreachApiApiOutreachApiMarkEnrollmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<MarkEnrollmentResponse> {
            return localVarFp.outreachApiMarkEnrollment(requestParameters.enrollmentId, requestParameters.markEnrollmentBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutreachApiApiOutreachApiRevealProspectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiRevealProspects(requestParameters: OutreachApiApiOutreachApiRevealProspectsRequest, options?: RawAxiosRequestConfig): AxiosPromise<RevealProspectsResponse> {
            return localVarFp.outreachApiRevealProspects(requestParameters.revealProspectsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutreachApiApiOutreachApiSearchCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiSearchCount(requestParameters: OutreachApiApiOutreachApiSearchCountRequest, options?: RawAxiosRequestConfig): AxiosPromise<SearchCountResponse> {
            return localVarFp.outreachApiSearchCount(requestParameters.searchProspectsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutreachApiApiOutreachApiSearchProspectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiSearchProspects(requestParameters: OutreachApiApiOutreachApiSearchProspectsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SearchProspectsResponse> {
            return localVarFp.outreachApiSearchProspects(requestParameters.searchProspectsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutreachApiApiOutreachApiSendOutreachEmailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiSendOutreachEmails(requestParameters: OutreachApiApiOutreachApiSendOutreachEmailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendOutreachEmailsResponse> {
            return localVarFp.outreachApiSendOutreachEmails(requestParameters.sendOutreachEmailsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutreachApiApiOutreachApiSetCampaignStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiSetCampaignStatus(requestParameters: OutreachApiApiOutreachApiSetCampaignStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<CampaignResponse> {
            return localVarFp.outreachApiSetCampaignStatus(requestParameters.campaignId, requestParameters.setCampaignStatusBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutreachApiApiOutreachApiSetCreditsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiSetCredits(requestParameters: OutreachApiApiOutreachApiSetCreditsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreditSummaryResponse> {
            return localVarFp.outreachApiSetCredits(requestParameters.setCreditsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutreachApiApiOutreachApiTagSuggestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiTagSuggest(requestParameters: OutreachApiApiOutreachApiTagSuggestRequest, options?: RawAxiosRequestConfig): AxiosPromise<TagSuggestResponse> {
            return localVarFp.outreachApiTagSuggest(requestParameters.q, requestParameters.kind, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutreachApiApiOutreachApiToggleIgnoreProspectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiToggleIgnoreProspect(requestParameters: OutreachApiApiOutreachApiToggleIgnoreProspectRequest, options?: RawAxiosRequestConfig): AxiosPromise<ToggleIgnoreResponse> {
            return localVarFp.outreachApiToggleIgnoreProspect(requestParameters.prospectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutreachApiApiOutreachApiUpdateCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outreachApiUpdateCampaign(requestParameters: OutreachApiApiOutreachApiUpdateCampaignRequest, options?: RawAxiosRequestConfig): AxiosPromise<CampaignResponse> {
            return localVarFp.outreachApiUpdateCampaign(requestParameters.campaignId, requestParameters.updateCampaignBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for outreachApiCreateCampaign operation in OutreachApiApi.
 */
export interface OutreachApiApiOutreachApiCreateCampaignRequest {
    readonly createCampaignBody: CreateCampaignBody
}

/**
 * Request parameters for outreachApiCreateSequenceFromAudience operation in OutreachApiApi.
 */
export interface OutreachApiApiOutreachApiCreateSequenceFromAudienceRequest {
    readonly createSequenceFromAudienceBody: CreateSequenceFromAudienceBody
}

/**
 * Request parameters for outreachApiDeleteCampaign operation in OutreachApiApi.
 */
export interface OutreachApiApiOutreachApiDeleteCampaignRequest {
    readonly campaignId: string
}

/**
 * Request parameters for outreachApiEnrichHiring operation in OutreachApiApi.
 */
export interface OutreachApiApiOutreachApiEnrichHiringRequest {
    readonly enrichHiringBody: EnrichHiringBody
}

/**
 * Request parameters for outreachApiEnrollProspects operation in OutreachApiApi.
 */
export interface OutreachApiApiOutreachApiEnrollProspectsRequest {
    readonly campaignId: string

    readonly enrollProspectsBody: EnrollProspectsBody
}

/**
 * Request parameters for outreachApiEnrollmentHistory operation in OutreachApiApi.
 */
export interface OutreachApiApiOutreachApiEnrollmentHistoryRequest {
    readonly enrollmentId: string
}

/**
 * Request parameters for outreachApiEstimateReveal operation in OutreachApiApi.
 */
export interface OutreachApiApiOutreachApiEstimateRevealRequest {
    readonly estimateRevealBody: EstimateRevealBody
}

/**
 * Request parameters for outreachApiExportForClaude operation in OutreachApiApi.
 */
export interface OutreachApiApiOutreachApiExportForClaudeRequest {
    readonly limit?: number

    readonly onlyUnknown?: boolean

    readonly searchBatchId?: string | null
}

/**
 * Request parameters for outreachApiGetCampaign operation in OutreachApiApi.
 */
export interface OutreachApiApiOutreachApiGetCampaignRequest {
    readonly campaignId: string
}

/**
 * Request parameters for outreachApiInboundReply operation in OutreachApiApi.
 */
export interface OutreachApiApiOutreachApiInboundReplyRequest {
    readonly ingestReplyBody: IngestReplyBody
}

/**
 * Request parameters for outreachApiListCampaigns operation in OutreachApiApi.
 */
export interface OutreachApiApiOutreachApiListCampaignsRequest {
    readonly status?: string | null
}

/**
 * Request parameters for outreachApiListEnrollments operation in OutreachApiApi.
 */
export interface OutreachApiApiOutreachApiListEnrollmentsRequest {
    readonly campaignId: string

    readonly page?: number

    readonly pageSize?: number

    readonly search?: string | null

    readonly status?: string | null
}

/**
 * Request parameters for outreachApiListProspects operation in OutreachApiApi.
 */
export interface OutreachApiApiOutreachApiListProspectsRequest {
    readonly hasAccount?: boolean | null

    readonly hasEmail?: boolean | null

    readonly hiringStatus?: string | null

    readonly hiringType?: string | null

    readonly includeIgnored?: boolean

    readonly isStaffingFirm?: boolean | null

    readonly minValueScore?: number | null

    readonly page?: number

    readonly pageSize?: number

    readonly revealStatus?: string | null

    readonly roleCategory?: string | null

    readonly searchBatchId?: string | null

    readonly searchQuery?: string | null

    readonly sort?: string

    readonly sortDir?: string | null
}

/**
 * Request parameters for outreachApiMarkEnrollment operation in OutreachApiApi.
 */
export interface OutreachApiApiOutreachApiMarkEnrollmentRequest {
    readonly enrollmentId: string

    readonly markEnrollmentBody: MarkEnrollmentBody
}

/**
 * Request parameters for outreachApiRevealProspects operation in OutreachApiApi.
 */
export interface OutreachApiApiOutreachApiRevealProspectsRequest {
    readonly revealProspectsBody: RevealProspectsBody
}

/**
 * Request parameters for outreachApiSearchCount operation in OutreachApiApi.
 */
export interface OutreachApiApiOutreachApiSearchCountRequest {
    readonly searchProspectsBody: SearchProspectsBody
}

/**
 * Request parameters for outreachApiSearchProspects operation in OutreachApiApi.
 */
export interface OutreachApiApiOutreachApiSearchProspectsRequest {
    readonly searchProspectsBody: SearchProspectsBody
}

/**
 * Request parameters for outreachApiSendOutreachEmails operation in OutreachApiApi.
 */
export interface OutreachApiApiOutreachApiSendOutreachEmailsRequest {
    readonly sendOutreachEmailsBody: SendOutreachEmailsBody
}

/**
 * Request parameters for outreachApiSetCampaignStatus operation in OutreachApiApi.
 */
export interface OutreachApiApiOutreachApiSetCampaignStatusRequest {
    readonly campaignId: string

    readonly setCampaignStatusBody: SetCampaignStatusBody
}

/**
 * Request parameters for outreachApiSetCredits operation in OutreachApiApi.
 */
export interface OutreachApiApiOutreachApiSetCreditsRequest {
    readonly setCreditsBody: SetCreditsBody
}

/**
 * Request parameters for outreachApiTagSuggest operation in OutreachApiApi.
 */
export interface OutreachApiApiOutreachApiTagSuggestRequest {
    readonly q: string

    readonly kind?: string | null
}

/**
 * Request parameters for outreachApiToggleIgnoreProspect operation in OutreachApiApi.
 */
export interface OutreachApiApiOutreachApiToggleIgnoreProspectRequest {
    readonly prospectId: string
}

/**
 * Request parameters for outreachApiUpdateCampaign operation in OutreachApiApi.
 */
export interface OutreachApiApiOutreachApiUpdateCampaignRequest {
    readonly campaignId: string

    readonly updateCampaignBody: UpdateCampaignBody
}

/**
 * OutreachApiApi - object-oriented interface
 */
export class OutreachApiApi extends BaseAPI {
    /**
     * 
     * @param {OutreachApiApiOutreachApiCreateCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public outreachApiCreateCampaign(requestParameters: OutreachApiApiOutreachApiCreateCampaignRequest, options?: RawAxiosRequestConfig) {
        return OutreachApiApiFp(this.configuration).outreachApiCreateCampaign(requestParameters.createCampaignBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutreachApiApiOutreachApiCreateSequenceFromAudienceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public outreachApiCreateSequenceFromAudience(requestParameters: OutreachApiApiOutreachApiCreateSequenceFromAudienceRequest, options?: RawAxiosRequestConfig) {
        return OutreachApiApiFp(this.configuration).outreachApiCreateSequenceFromAudience(requestParameters.createSequenceFromAudienceBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public outreachApiCreditSummary(options?: RawAxiosRequestConfig) {
        return OutreachApiApiFp(this.configuration).outreachApiCreditSummary(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutreachApiApiOutreachApiDeleteCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public outreachApiDeleteCampaign(requestParameters: OutreachApiApiOutreachApiDeleteCampaignRequest, options?: RawAxiosRequestConfig) {
        return OutreachApiApiFp(this.configuration).outreachApiDeleteCampaign(requestParameters.campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutreachApiApiOutreachApiEnrichHiringRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public outreachApiEnrichHiring(requestParameters: OutreachApiApiOutreachApiEnrichHiringRequest, options?: RawAxiosRequestConfig) {
        return OutreachApiApiFp(this.configuration).outreachApiEnrichHiring(requestParameters.enrichHiringBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutreachApiApiOutreachApiEnrollProspectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public outreachApiEnrollProspects(requestParameters: OutreachApiApiOutreachApiEnrollProspectsRequest, options?: RawAxiosRequestConfig) {
        return OutreachApiApiFp(this.configuration).outreachApiEnrollProspects(requestParameters.campaignId, requestParameters.enrollProspectsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutreachApiApiOutreachApiEnrollmentHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public outreachApiEnrollmentHistory(requestParameters: OutreachApiApiOutreachApiEnrollmentHistoryRequest, options?: RawAxiosRequestConfig) {
        return OutreachApiApiFp(this.configuration).outreachApiEnrollmentHistory(requestParameters.enrollmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutreachApiApiOutreachApiEstimateRevealRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public outreachApiEstimateReveal(requestParameters: OutreachApiApiOutreachApiEstimateRevealRequest, options?: RawAxiosRequestConfig) {
        return OutreachApiApiFp(this.configuration).outreachApiEstimateReveal(requestParameters.estimateRevealBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutreachApiApiOutreachApiExportForClaudeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public outreachApiExportForClaude(requestParameters: OutreachApiApiOutreachApiExportForClaudeRequest = {}, options?: RawAxiosRequestConfig) {
        return OutreachApiApiFp(this.configuration).outreachApiExportForClaude(requestParameters.limit, requestParameters.onlyUnknown, requestParameters.searchBatchId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutreachApiApiOutreachApiGetCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public outreachApiGetCampaign(requestParameters: OutreachApiApiOutreachApiGetCampaignRequest, options?: RawAxiosRequestConfig) {
        return OutreachApiApiFp(this.configuration).outreachApiGetCampaign(requestParameters.campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutreachApiApiOutreachApiInboundReplyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public outreachApiInboundReply(requestParameters: OutreachApiApiOutreachApiInboundReplyRequest, options?: RawAxiosRequestConfig) {
        return OutreachApiApiFp(this.configuration).outreachApiInboundReply(requestParameters.ingestReplyBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutreachApiApiOutreachApiListCampaignsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public outreachApiListCampaigns(requestParameters: OutreachApiApiOutreachApiListCampaignsRequest = {}, options?: RawAxiosRequestConfig) {
        return OutreachApiApiFp(this.configuration).outreachApiListCampaigns(requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutreachApiApiOutreachApiListEnrollmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public outreachApiListEnrollments(requestParameters: OutreachApiApiOutreachApiListEnrollmentsRequest, options?: RawAxiosRequestConfig) {
        return OutreachApiApiFp(this.configuration).outreachApiListEnrollments(requestParameters.campaignId, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutreachApiApiOutreachApiListProspectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public outreachApiListProspects(requestParameters: OutreachApiApiOutreachApiListProspectsRequest = {}, options?: RawAxiosRequestConfig) {
        return OutreachApiApiFp(this.configuration).outreachApiListProspects(requestParameters.hasAccount, requestParameters.hasEmail, requestParameters.hiringStatus, requestParameters.hiringType, requestParameters.includeIgnored, requestParameters.isStaffingFirm, requestParameters.minValueScore, requestParameters.page, requestParameters.pageSize, requestParameters.revealStatus, requestParameters.roleCategory, requestParameters.searchBatchId, requestParameters.searchQuery, requestParameters.sort, requestParameters.sortDir, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutreachApiApiOutreachApiMarkEnrollmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public outreachApiMarkEnrollment(requestParameters: OutreachApiApiOutreachApiMarkEnrollmentRequest, options?: RawAxiosRequestConfig) {
        return OutreachApiApiFp(this.configuration).outreachApiMarkEnrollment(requestParameters.enrollmentId, requestParameters.markEnrollmentBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutreachApiApiOutreachApiRevealProspectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public outreachApiRevealProspects(requestParameters: OutreachApiApiOutreachApiRevealProspectsRequest, options?: RawAxiosRequestConfig) {
        return OutreachApiApiFp(this.configuration).outreachApiRevealProspects(requestParameters.revealProspectsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutreachApiApiOutreachApiSearchCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public outreachApiSearchCount(requestParameters: OutreachApiApiOutreachApiSearchCountRequest, options?: RawAxiosRequestConfig) {
        return OutreachApiApiFp(this.configuration).outreachApiSearchCount(requestParameters.searchProspectsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutreachApiApiOutreachApiSearchProspectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public outreachApiSearchProspects(requestParameters: OutreachApiApiOutreachApiSearchProspectsRequest, options?: RawAxiosRequestConfig) {
        return OutreachApiApiFp(this.configuration).outreachApiSearchProspects(requestParameters.searchProspectsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutreachApiApiOutreachApiSendOutreachEmailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public outreachApiSendOutreachEmails(requestParameters: OutreachApiApiOutreachApiSendOutreachEmailsRequest, options?: RawAxiosRequestConfig) {
        return OutreachApiApiFp(this.configuration).outreachApiSendOutreachEmails(requestParameters.sendOutreachEmailsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutreachApiApiOutreachApiSetCampaignStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public outreachApiSetCampaignStatus(requestParameters: OutreachApiApiOutreachApiSetCampaignStatusRequest, options?: RawAxiosRequestConfig) {
        return OutreachApiApiFp(this.configuration).outreachApiSetCampaignStatus(requestParameters.campaignId, requestParameters.setCampaignStatusBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutreachApiApiOutreachApiSetCreditsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public outreachApiSetCredits(requestParameters: OutreachApiApiOutreachApiSetCreditsRequest, options?: RawAxiosRequestConfig) {
        return OutreachApiApiFp(this.configuration).outreachApiSetCredits(requestParameters.setCreditsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutreachApiApiOutreachApiTagSuggestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public outreachApiTagSuggest(requestParameters: OutreachApiApiOutreachApiTagSuggestRequest, options?: RawAxiosRequestConfig) {
        return OutreachApiApiFp(this.configuration).outreachApiTagSuggest(requestParameters.q, requestParameters.kind, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutreachApiApiOutreachApiToggleIgnoreProspectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public outreachApiToggleIgnoreProspect(requestParameters: OutreachApiApiOutreachApiToggleIgnoreProspectRequest, options?: RawAxiosRequestConfig) {
        return OutreachApiApiFp(this.configuration).outreachApiToggleIgnoreProspect(requestParameters.prospectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutreachApiApiOutreachApiUpdateCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public outreachApiUpdateCampaign(requestParameters: OutreachApiApiOutreachApiUpdateCampaignRequest, options?: RawAxiosRequestConfig) {
        return OutreachApiApiFp(this.configuration).outreachApiUpdateCampaign(requestParameters.campaignId, requestParameters.updateCampaignBody, options).then((request) => request(this.axios, this.basePath));
    }
}

